import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onSuccess", "onClose", "reAuthObject", "email"];
import { useState } from 'react';
import PromptWrapper from './TwoFactorPrompt/PromptWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { usePasskeyValidation } from '../hooks/usePasskeyValidation';
import { useTwoFactorReAuth } from '../hooks/useTwoFactorReAuth';
import TwoFactorPromptContainer from '../containers/TwoFactorPromptContainer';
import Images from '../images/imageUrls';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function VerificationOptions(_ref) {
  let {
      onSuccess,
      onClose,
      reAuthObject,
      email
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isTwoFactorReady, setIsTwoFactorReady] = useState(false);
  const {
    hasSecondaryMethod,
    obfuscatedInfo,
    authMethod,
    initializeTwoFactorReAuth
  } = useTwoFactorReAuth();
  const {
    validateWithPasskey
  } = usePasskeyValidation({
    onSuccess,
    onClose,
    handleError: () => initializeTwoFactorReAuth(Object.assign({}, reAuthObject, {
      openModal: () => setIsTwoFactorReady(true)
    }))
  });
  const passkeyVerification = async () => {
    await validateWithPasskey(email);
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isTwoFactorReady ? /*#__PURE__*/_jsx(TwoFactorPromptContainer, Object.assign({}, props, {
      onSuccess: onSuccess,
      isOpen: isTwoFactorReady,
      onClose: onClose,
      authMethod: authMethod,
      obfuscatedInfo: obfuscatedInfo,
      hasSecondaryMethod: hasSecondaryMethod
    })) : /*#__PURE__*/_jsx(PromptWrapper, {
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsxs(View, {
          children: [/*#__PURE__*/_jsx(Button, {
            use: "primary",
            "data-test-id": "passkey-verification-button",
            onClick: () => void passkeyVerification(),
            block: true,
            marginBlockEnd: "200",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              justifyContent: "center",
              gap: "50",
              children: [/*#__PURE__*/_jsx(Image, {
                responsive: false,
                inlineSize: "22px",
                src: Images.passkeyLogo
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "reAuth.verificationOptions.passkey"
              })]
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "secondary",
            "data-test-id": "2fa-verification-button",
            onClick: () => initializeTwoFactorReAuth(Object.assign({}, reAuthObject, {
              openModal: () => setIsTwoFactorReady(true)
            })),
            block: true,
            marginInline: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "reAuth.verificationOptions.twoFactor"
            })
          })]
        })
      })
    })
  });
}